/**
 * Feeds the Axios interceptor with the current region: it runs outside React, so it cannot read
 * the region through `useRegion`. `RegionProvider` pushes the value in on every render.
 */
import { DEFAULT_REGION } from './constants';
var currentRegion = DEFAULT_REGION;
export var getCurrentRegion = function getCurrentRegion() {
    return currentRegion;
};
export var setCurrentRegion = function setCurrentRegion(region) {
    currentRegion = region;
};
